<ion-header>
  <ion-toolbar>
    <ion-title>{{ "home.missingHours" | translate }}</ion-title>
    @if(!state.isBigScreen){
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon size="large" name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    } @if(state.isBigScreen){
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon size="large" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    }
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="custom-table">
    <div class="row header">
      <div class="col">
        <ion-checkbox
          [(ngModel)]="allSelected"
          (ionChange)="toggleAll($event.detail.checked)"
          (click)="$event.stopPropagation()"
        ></ion-checkbox>
      </div>

      <div class="col">{{ "common.date" | translate }}</div>
      <div class="col grow">{{ "common.name" | translate }}</div>
    </div>

    @for (entry of entries; track entry) {
    <div class="row">
      <div class="col">
        <ion-checkbox
          (click)="$event.stopPropagation()"
          [checked]="isSelected(entry.id)"
          (ionChange)="toggleSelection(entry.id, $event.detail.checked)"
        >
        </ion-checkbox>
      </div>
      <div class="col">{{ entry.date | date : "EE, dd.MM.yyyy" }}</div>
      <div class="col grow">
        {{ state.getUserDisplayNameAsync(entry.user) | async }}
      </div>
    </div>
    }
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="footer-buttons">
      <ion-button
        color="danger"
        [disabled]="selectedIds.size == 0"
        (click)="delete()"
      >
        {{ "common.delete" | translate }}
      </ion-button>

      <ion-button [disabled]="!sameDateSelected" (click)="openAbsenceForm()">
        {{ "absence.createRequest" | translate }}
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
